import React from 'react';
import { Media } from 'reactstrap';
// import { Btn, Image } from '../../AbstractElements';
import { Navigator } from '../Table/Defaultdata';

const style2 = { width: 60, fontSize: 14, padding: 4 };
export const pharmacytabledata = [
    {
        id: 1,
        category:"Antipyratics" ,
        medicinename: "imon plus",
        price: 20,
        stockavailable: 300,
        action: <span>
        {/* <Btn attrBtn={{ style: style2, color: 'success', className: 'btn btn-xs', type: 'button' }}>Edit </Btn> */}
        <Navigator to={`${process.env.PUBLIC_URL}/pharmacyform/:layout`}/>
      </span>
        // budget: '$3142.00',

    },
];

export const tableColumns = [
    {
        name: '#',
        selector: row => row['id'],
        sortable: true,
        center: false,
    },
    {
        name: 'Category',
        selector: row => row['category'],
        sortable: true,
        center: false,
    },
    {
        name: 'Medicine Name',
        selector: row => row['medicinename'],
        sortable: true,
        center: true,
    },
    {
      name: 'Price',
      selector: row => `${row.price}`,
      sortable: true,
      center: true,
  },
    {
      name: 'Stock Available',
      selector: row => `${row.stockavailable}`,
      sortable: true,
      center: true,
  },
    {
        name: 'Action',
        selector: row => row['action'],
        sortable: false,
        center: true,
    },
];